export default __webpack_public_path__ + "static/media/stage.8de4f678.png";